import { useGetReferralSitesV3Query } from '@/entities/referrals/api/referralsApi';
import optionsToIds from '@/entities/sites/ui/site-select/lib/optionsToIds';
import SiteSelect from '@/entities/sites/ui/site-select/ui';
import { FilterState } from '@/shared/lib/filter/model/types';

export interface ISiteSelect {
  value: FilterState['referralsSites'];
  onChange: (value: FilterState['referralsSites']) => void;
}

export default function ReferralSitesSelect({ value, onChange }: ISiteSelect) {
  const getReferralSitesV3Query = useGetReferralSitesV3Query();
  const sites = getReferralSitesV3Query.data?.map((site) => ({
    id: site.id,
    url: site.domain,
  }));

  return (
    <div className="min-w-[90px]">
      <SiteSelect
        data={sites}
        current={value}
        onChange={(option) => {
          onChange(optionsToIds(option));
        }}
      />
    </div>
  );
}
